export default __webpack_public_path__ + "static/tech-synology-8403c192e3fbfd5fc9157fa6005f126d-8403c192e3fbfd5fc9157fa6005f126d.png";